export const getShouldRenderBinInventoryFeature = (
  accountBinInventoryFeature: boolean | undefined,
  branchBinInventoryFeature: boolean | undefined,
) => {
  return (
    accountBinInventoryFeature === true && branchBinInventoryFeature === true
  )
}
